import request from '@/utils/request'

export function login (userName, passWord) {
  return request({
    url: '/admin/login',
    method: 'post',
    params: { userName, passWord }
  })
}

export function getInfo () {
  return request({
    url: '/admin/info',
    method: 'get'
  })
}

/** 启动鉴权：adminId + actions + permVersion */
export function getAuth () {
  return request({
    url: '/admin/auth',
    method: 'get'
  })
}

/** 强制刷新服务端权限缓存 */
export function reloadAuth () {
  return request({
    url: '/admin/auth/reload',
    method: 'post'
  })
}

export function getActions () {
  return request({
    url: '/admin/actions',
    method: 'get'
  })
}

export function logout () {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function bannerList (params) {
  return request({
    url: '/admin/banner/list',
    method: 'post',
    data: params
  })
}

export function bannerSave (data) {
  return request({
    url: '/admin/banner/save',
    method: 'post',
    data
  })
}

export function bannerState (id, state) {
  return request({
    url: '/admin/banner/state',
    method: 'post',
    data: { id, state }
  })
}

export function bannerDelete (id) {
  return request({
    url: '/admin/banner/delete',
    method: 'post',
    data: { id }
  })
}

/** 通用文件上传（APK/IPA 等），返回 data=文件 URL */
export function uploadFile (file) {
  const form = new FormData()
  form.append('file', file)
  return request({
    url: '/file/upload',
    method: 'post',
    data: form,
    timeout: 300000
  })
}

/** FastDFS 图片上传：自动生成缩略图，兼容返回 data=原图URL，同时带 thumbnailUrl */
export function uploadImage (file) {
  const form = new FormData()
  form.append('file', file)
  return request({
    url: '/file/uploadImageWithThumb',
    method: 'post',
    data: form,
    timeout: 60000
  }).then(res => {
    const raw = res && res.data
    if (raw && typeof raw === 'object') {
      const imageUrl = raw.imageUrl || ''
      const thumbnailUrl = raw.thumbnailUrl || imageUrl
      return {
        ...res,
        data: imageUrl,
        imageUrl,
        thumbnailUrl,
        raw
      }
    }
    return res
  })
}

/** 上传图片并自动生成缩略图，返回 { imageUrl, thumbnailUrl } */
export function uploadImageWithThumb (file) {
  const form = new FormData()
  form.append('file', file)
  return request({
    url: '/file/uploadImageWithThumb',
    method: 'post',
    data: form,
    timeout: 60000
  })
}

export function getProfile () {
  return request({
    url: '/admin/profile',
    method: 'get'
  })
}

export function updateProfile (data) {
  return request({
    url: '/admin/profile/update',
    method: 'post',
    data
  })
}

export function changePassword (data) {
  return request({
    url: '/admin/profile/password',
    method: 'post',
    data
  })
}

export function accountList (params) {
  return request({
    url: '/admin/account/list',
    method: 'post',
    data: params
  })
}

export function accountDetail (id) {
  return request({
    url: '/admin/account/detail',
    method: 'post',
    data: { id }
  })
}

export function accountSave (data) {
  return request({
    url: '/admin/account/save',
    method: 'post',
    data
  })
}

export function accountState (id, state) {
  return request({
    url: '/admin/account/state',
    method: 'post',
    data: { id, state }
  })
}

export function accountDelete (id) {
  return request({
    url: '/admin/account/delete',
    method: 'post',
    data: { id }
  })
}

export function roleList (params) {
  return request({
    url: '/admin/role/list',
    method: 'post',
    data: params
  })
}

export function roleSave (data) {
  return request({
    url: '/admin/role/save',
    method: 'post',
    data
  })
}

export function roleDelete (id) {
  return request({
    url: '/admin/role/delete',
    method: 'post',
    data: { id }
  })
}

export function roleAllActions () {
  return request({
    url: '/admin/role/actions',
    method: 'post'
  })
}

export function roleActionIds (roleId) {
  return request({
    url: '/admin/role/actionIds',
    method: 'post',
    data: { roleId }
  })
}

export function roleAssignActions (data) {
  return request({
    url: '/admin/role/assignActions',
    method: 'post',
    data
  })
}

export function actionList (params) {
  return request({
    url: '/admin/action/list',
    method: 'post',
    data: params
  })
}

export function actionAll () {
  return request({
    url: '/admin/action/all',
    method: 'post'
  })
}

export function actionDetail (id) {
  return request({
    url: '/admin/action/detail',
    method: 'post',
    data: { id }
  })
}

export function actionSave (data) {
  return request({
    url: '/admin/action/save',
    method: 'post',
    data
  })
}

export function actionDelete (id) {
  return request({
    url: '/admin/action/delete',
    method: 'post',
    data: { id }
  })
}

export function announcementList (params) {
  return request({
    url: '/admin/announcement/list',
    method: 'get',
    params
  })
}

export function announcementDetail (id) {
  return request({
    url: '/admin/announcement/detail',
    method: 'get',
    params: { id }
  })
}

export function announcementSave (data) {
  return request({
    url: '/admin/announcement/save',
    method: 'post',
    data
  })
}

export function announcementState (id, state) {
  return request({
    url: '/admin/announcement/state',
    method: 'post',
    params: { id, state }
  })
}

export function announcementDelete (id) {
  return request({
    url: '/admin/announcement/delete',
    method: 'post',
    params: { id }
  })
}

export function collectList (params) {
  return request({
    url: '/admin/collect/list',
    method: 'get',
    params
  })
}

export function collectDetail (id) {
  return request({
    url: '/admin/collect/detail',
    method: 'get',
    params: { id }
  })
}

export function collectSave (data) {
  return request({
    url: '/admin/collect/save',
    method: 'post',
    data
  })
}

export function collectDelete (id) {
  return request({
    url: '/admin/collect/delete',
    method: 'post',
    params: { id }
  })
}

export function collectCountries (params) {
  return request({
    url: '/admin/collect/countries',
    method: 'get',
    params
  })
}

export function countryOptions (params) {
  return request({
    url: '/admin/country/options',
    method: 'get',
    params
  })
}

export function collectMaterials () {
  return request({
    url: '/admin/collect/materials',
    method: 'get'
  })
}

export function collectDict (parent) {
  return request({
    url: '/admin/collect/dict',
    method: 'get',
    params: { parent }
  })
}

export function collectSeriesOptions (params) {
  return request({
    url: '/admin/collect/seriesOptions',
    method: 'get',
    params
  })
}

export function collectDynasties () {
  return request({
    url: '/admin/collect/dynasties',
    method: 'get'
  })
}

export function collectNumismaticsGroups () {
  return request({ url: '/admin/collect/numismatics/groups', method: 'get' })
}

export function collectNumismaticsRegimes (group) {
  return request({ url: '/admin/collect/numismatics/regimes', method: 'get', params: { group } })
}

export function collectNumismaticsEras (group, regime) {
  return request({ url: '/admin/collect/numismatics/eras', method: 'get', params: { group, regime } })
}

export function collectNumismaticsLookup (regime, era) {
  return request({ url: '/admin/collect/numismatics/lookup', method: 'get', params: { regime, era } })
}

export function countryList (params) {
  return request({ url: '/admin/country/list', method: 'get', params })
}

export function countrySave (data) {
  return request({ url: '/admin/country/save', method: 'post', data })
}

export function countryDelete (id) {
  return request({ url: '/admin/country/delete', method: 'post', params: { id } })
}

export function countrySetOnline (data) {
  return request({ url: '/admin/country/setOnline', method: 'post', data })
}

export function countrySetOnlineByRegion (data) {
  return request({ url: '/admin/country/setOnlineByRegion', method: 'post', data })
}

export function collectBatchSetOnline (data) {
  return request({ url: '/admin/collect/batchSetOnline', method: 'post', data })
}

export function dynastyList (params) {
  return request({ url: '/admin/dynasty/list', method: 'get', params })
}

export function dynastyAll () {
  return request({ url: '/admin/dynasty/all', method: 'get' })
}

export function dynastySave (data) {
  return request({ url: '/admin/dynasty/save', method: 'post', data })
}

export function dynastyDelete (id) {
  return request({ url: '/admin/dynasty/delete', method: 'post', params: { id } })
}

export function dynastySetOnline (data) {
  return request({ url: '/admin/dynasty/setOnline', method: 'post', data })
}

export function dynastyRefreshCatalogCache () {
  return request({ url: '/admin/dynasty/refreshCatalogCache', method: 'post' })
}

export function articleList (params) {
  return request({ url: '/admin/article/list', method: 'post', data: params })
}

export function articleDetail (id) {
  return request({ url: '/admin/article/detail', method: 'post', data: { id } })
}

export function articleSave (data) {
  return request({ url: '/admin/article/save', method: 'post', data })
}

export function articleState (id, state) {
  return request({ url: '/admin/article/state', method: 'post', data: { id, state } })
}

export function articleDelete (id) {
  return request({ url: '/admin/article/delete', method: 'post', data: { id } })
}

export function userList (params) {
  return request({
    url: '/admin/user/list',
    method: 'post',
    data: params
  })
}

export function userDetail (id) {
  return request({
    url: '/admin/user/detail',
    method: 'post',
    data: { id }
  })
}

export function userCheckins (id) {
  return request({
    url: '/admin/user/checkins',
    method: 'post',
    data: { id }
  })
}

export function userState (id, state) {
  return request({
    url: '/admin/user/state',
    method: 'post',
    data: { id, state }
  })
}

export function userGrantMember (id, days) {
  return request({
    url: '/admin/user/grantMember',
    method: 'post',
    data: { id, days }
  })
}

export function userPointsLogs (data) {
  return request({
    url: '/admin/user/pointsLogs',
    method: 'post',
    data
  })
}

export function userAdjustPoints (id, points, remark) {
  return request({
    url: '/admin/user/adjustPoints',
    method: 'post',
    data: { id, points, remark }
  })
}

export function contributionList (params) {
  return request({
    url: '/admin/contribution/list',
    method: 'get',
    params
  })
}

export function contributionDetail (id) {
  return request({
    url: '/admin/contribution/detail',
    method: 'get',
    params: { id }
  })
}

export function contributionApprove (id) {
  return request({
    url: '/admin/contribution/approve',
    method: 'post',
    params: { id }
  })
}

export function contributionReject (id, remark) {
  return request({
    url: '/admin/contribution/reject',
    method: 'post',
    params: { id, remark }
  })
}

export function correctionList (params) {
  return request({ url: '/admin/correction/list', method: 'get', params })
}

export function correctionDetail (id) {
  return request({ url: '/admin/correction/detail', method: 'get', params: { id } })
}

export function correctionHandle (data) {
  return request({ url: '/admin/correction/handle', method: 'post', data })
}

export function appVersionList (params) {
  return request({ url: '/admin/appVersion/list', method: 'get', params })
}

export function appVersionDetail (id) {
  return request({ url: '/admin/appVersion/detail', method: 'get', params: { id } })
}

export function appVersionSave (data) {
  return request({ url: '/admin/appVersion/save', method: 'post', data })
}

export function appVersionState (id, state) {
  return request({ url: '/admin/appVersion/state', method: 'post', params: { id, state } })
}

export function appVersionDelete (id) {
  return request({ url: '/admin/appVersion/delete', method: 'post', params: { id } })
}

export function membershipProductList (params) {
  return request({ url: '/admin/membershipProduct/list', method: 'get', params })
}

export function membershipProductDetail (id) {
  return request({ url: '/admin/membershipProduct/detail', method: 'get', params: { id } })
}

export function membershipProductSave (data) {
  return request({ url: '/admin/membershipProduct/save', method: 'post', data })
}

export function membershipProductState (id, state) {
  return request({ url: '/admin/membershipProduct/state', method: 'post', params: { id, state } })
}

export function membershipProductDelete (id) {
  return request({ url: '/admin/membershipProduct/delete', method: 'post', params: { id } })
}

export function settingList (params) {
  return request({ url: '/admin/setting/list', method: 'get', params })
}

export function settingDetail (id) {
  return request({ url: '/admin/setting/detail', method: 'get', params: { id } })
}

export function settingSave (data) {
  return request({ url: '/admin/setting/save', method: 'post', data })
}

export function settingDelete (id) {
  return request({ url: '/admin/setting/delete', method: 'post', params: { id } })
}

export function orderList (params) {
  return request({ url: '/admin/order/list', method: 'post', data: params })
}

export function orderDetail (id) {
  return request({ url: '/admin/order/detail', method: 'post', data: { id } })
}

export function orderRefund (id) {
  return request({ url: '/admin/order/refund', method: 'post', data: { id } })
}

export function feedbackList (params) {
  return request({ url: '/admin/feedback/list', method: 'get', params })
}

export function feedbackDetail (id) {
  return request({ url: '/admin/feedback/detail', method: 'get', params: { id } })
}

export function feedbackReply (id, reply) {
  return request({
    url: '/admin/feedback/reply',
    method: 'post',
    data: { id, reply }
  })
}

export function feedbackDelete (id) {
  return request({ url: '/admin/feedback/delete', method: 'post', params: { id } })
}

export function pushList (params) {
  return request({ url: '/admin/push/list', method: 'get', params })
}

export function pushDetail (id) {
  return request({ url: '/admin/push/detail', method: 'get', params: { id } })
}

export function pushSend (data) {
  return request({ url: '/admin/push/send', method: 'post', data })
}

export function smsList (params) {
  return request({ url: '/admin/sms/list', method: 'post', data: params })
}

export function sysLogList (params) {
  return request({ url: '/admin/sysLog/list', method: 'post', data: params })
}

export function dashboardOverview () {
  return request({ url: '/admin/dashboard/overview', method: 'get' })
}

export function statisticsSummary () {
  return request({ url: '/admin/statistics/summary', method: 'get' })
}

export function statisticsTrend (params) {
  return request({ url: '/admin/statistics/trend', method: 'get', params })
}

export function statisticsSnapshot (params) {
  return request({ url: '/admin/statistics/snapshot', method: 'post', params })
}

export function statisticsList (params) {
  return request({ url: '/admin/statistics/list', method: 'get', params })
}

export function monitorOverview () {
  return request({ url: '/admin/monitor/overview', method: 'get' })
}

export function documentList (params) {
  return request({ url: '/admin/document/list', method: 'get', params })
}

export function documentDetail (id) {
  return request({ url: '/admin/document/detail', method: 'get', params: { id } })
}

export function documentSave (data) {
  return request({ url: '/admin/document/save', method: 'post', data })
}

export function documentState (id, state) {
  return request({ url: '/admin/document/state', method: 'post', params: { id, state } })
}
